import React from "react";
import AnimatedLine from "../../components/animatedLine/AnimatedLine";

const wytchnienieData = {
  headerSlogan: (
    <>
      <AnimatedLine cName="center-header" text="Akcja" />
      <AnimatedLine cName="accent center-header" text="PIT STOP WYTCHNIENIE" />
    </>
  ),
  landingText: (
    <>
      Fundacja Mleko i Miód, Fundacja Malak i SJS wraz z Bartkiem Ostałowskim
      organizują akcję charytatywną, która ma jeden cel — zebranie funduszy na
      wsparcie obszaru opieki wytchnieniowej. Historia Bartka pokazuje, że
      niepełnosprawność nie musi ograniczać i można zdobywać szczyty nie mając
      rąk. Natomiast jest też taka niepełnosprawność, gdzie 100% egzystencji
      zależy od drugiego człowieka.
      <br />
      <br />
      Rodzice, opiekunowie osób z niepełnosprawnościami to cisi bohaterowie,
      którzy poświęcają całe życie na rzecz opieki nad swoim chorym dzieckiem,
      podopiecznym. Często przez całe lata nie mają ani chwili dla siebie.
      Chcemy to zmienić i dać im możliwość odpoczynku i wytchnienia!
    </>
  ),

  headerCoKonkretnie: (
    <>
      <AnimatedLine text="Co konkretnie" />
      <AnimatedLine cName="accent" text="zrobimy?" />
    </>
  ),
  textCoKonkretnie: (
    <>
      Chcemy stworzyć oddział opieki wytchnieniowej w Centrum Wsparcia i Terapii
      Osób Niepełnosprawnych i Ich Rodzin w Kluczach:
      <ul>
        <li>
          kupić meble, łóżka, specjalistyczny sprzęt medyczny - wszystko co jest
          konieczne do zapewnienia całodobowej, weekendowej opieki nad osobami z
          niepełnosprawnościami.
        </li>
        <li>
          opłacić regularne funkcjonowanie oddziału opieki wytchnieniowej
          (wynagrodzenie dla profesjonalnej kadry specjalistów, którzy będą
          zostawać z podopiecznymi w weekendy, aby rodzice bądź opiekunowie
          prawni osób z niepełnosprawnościami mogli odpocząć i zrobić coś dla
          siebie).
        </li>
      </ul>
    </>
  ),
  centrumLink:
    "https://psoni-wolbrom.pl/centrum-wsparcia-i-terapii-osob-niepelnosprawnych-i-ich-rodzin-w-kluczach/",

  headerJakMozeszPomoc: (
    <>
      <AnimatedLine text="Jak możesz" />
      <AnimatedLine cName="accent" text="pomóc?" />
    </>
  ),
  textJakMozeszPomoc: (
    <>
      <strong>Wpłać darowiznę na rzecz Fundacji Mleko i Miód</strong>
      <br />
      <br />
      <strong>Weź udział w rywalizacji na torze wyścigowym!</strong>
    </>
  ),

  headerNaCzymPolega: (
    <>
      <AnimatedLine text="Na czym polega" />
      <AnimatedLine cName="accent" text="wyzwanie?" />
    </>
  ),
  textNaCzymPolega: (
    <>
      To proste: zmierz się z Bartkiem Ostałowskim - jedynym na świecie
      drifterem prowadzącym samochód stopą!!! Wykup przejazd na Torze Miedziana
      Góra w Kielcach, ścigaj się Toyotą Yaris GT na czas, wrzuć wynik na
      tablicę rankingową. Każdy czas się liczy, a dla najszybszych czeka Puchar
      „Pit Stop Wytchnienie"! Ale najważniejsze - wpłata za Twoją jazdę
      przekazywana jest na rzecz Akcji "Pit Stop Wytchnienie"!
      <ul>
        <li>
          <strong>Ranking:</strong> Tabela wyników będzie na bieżąco
          aktualizowana i dostępna zarówno na torze, jak i w mediach
          społecznościowych organizatorów.
        </li>
        <li>
          <strong>Nominacje:</strong> Po swoim przejeździe, każdy uczestnik może
          rzucić komuś wyzwanie do pobicia swojego czasu i tym samym zaprosić do
          wsparcia Akcji!
        </li>
        <li>
          <strong>Poprawka:</strong> Ktoś pobił Twój czas? A może po prostu
          czujesz, że możesz pojechać szybciej? Aby poprawić swój wynik,
          wystarczy wpłacić kolejną cegiełkę i ponownie stanąć na starcie.
        </li>
      </ul>
    </>
  ),

  textPartnerzy: (
    <>
      Dzięki firmie SJS, która udostępnia tor i firmie Omnipro, która dba o
      nagłośnienie naszej akcji, możemy połączyć konkretne pomaganie z
      motosportem! Zresztą sami zobaczcie!
    </>
  ),

  textFinale: (
    <>
      Dołącz do Akcji, powiedz o niej swoim znajomym i wspólnie ZRÓBMY COŚ
      DOBREGO dla osób, które całkowicie zależą od drugiego człowieka!
    </>
  ),

  organizatorzy: "Organizatorzy: Fundacja Mleko i Miód, Fundacja Malak, SJS",
  partnerzy: "Partnerzy: omnipro sp. z o.o.",
  ambasador:
    "Ambasador Akcji: Bartosz Ostałowski - jedyny na świecie kierowca rajdowy kierujący nogami!",
};

export default wytchnienieData;
